import Polyfill from "./Polyfill";
import { Helpers } from "../../common/js/Helpers";


/**
 * this class is the basic modal of Event Gallery.
 */
export default class Overlay {

    /**
     * @param parent HTML element to append the modal to.
     */
    constructor(parent = document.body) {
        this.isOpen = false;
        this.myDialogElement = null; // This will hold the dialog element
        this.parent = parent
        this.onClosed = undefined;
        this.onLoad = undefined;
    }

    /**
     * opens an overlay. The content can be a url or content.
     * Url start with http or /
     *
     * @param dataUrl
     */
    openOverlay(dataUrl) {

        this.isOpen = true;

        // Remove existing overlay if any (though usually we create a new instance)
        const existing = document.getElementById('eventgallery-overlay');
        if (existing) {
            existing.remove();
        }

        this.myDialogElement = document.createElement('dialog');
        this.myDialogElement.id = 'eventgallery-overlay';

        // Basic dialog styling to ensure it looks reasonable if no CSS is present
        // But relying on user's css class 'eventgallery-close-overlay' suggests they have styles.
        // We add a loading spinner initially
        this.myDialogElement.innerHTML = '<i class="egfa egfa-2x egfa-cog egfa-spin"></i>';

        this.parent.append(this.myDialogElement);

        // Native dialog has a ::backdrop, so we don't need a separate background div unless for specific styling
        // However, we want to close on backdrop click if desired.
        this.myDialogElement.addEventListener('click', (event) => {
            if (event.target === event.currentTarget) {
                this.closeOverlay();
            }
        });

        this.myDialogElement.showModal();

        if (dataUrl.startsWith('http') || dataUrl.startsWith('/')) {
            Overlay._getRemoteData(dataUrl, (data) => {
                this._addContent(data);
            })
        } else {
            this._addContent(`<button class="btn-close-overlay eventgallery-close-overlay"><i class="egfa egfa-2x egfa-times-circle"></i></button>` + dataUrl);
        }
    }


    static _getRemoteData(url, callback) {
        fetch(url)
            .then(response => response.text())
            .then(data => callback(data));
    }

    /**
     * moves the given content into the content overlay. Executes the onload method when finished.
     *
     * @param content
     * @private
     */
    _addContent(content) {
        Helpers.insertAndExecute(this.myDialogElement, content);

        let elements = this.myDialogElement.getElementsByClassName('eventgallery-close-overlay');
        for (let i = 0; i < elements.length; i++) {
            elements[i].addEventListener('click', (e) => {
                e.preventDefault();
                this.closeOverlay()
            });
        }

        if (this.onLoad !== undefined) {
            this.onLoad();
        }

        document.dispatchEvent(Polyfill.createNewEvent('eventgallery-images-added', { isOverlay: true }));
    }

    /**
     * Closes the overlay and fires the onclose method if defined.
     */
    closeOverlay() {
        this.isOpen = false;

        if (this.myDialogElement) {
            this.myDialogElement.close();
            Polyfill.removeHtmlElementNode(this.myDialogElement);
            this.myDialogElement = null;
        }

        if (this.onClosed !== undefined) {
            this.onClosed();
        }
    }
}
